import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { stringify } from '../../../utils';
import { collectBrowserInfo } from '../collectBrowserInfo';
import { threeDsErrors } from '../3ds-utils';
const log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'worldpay-fingerprint',
});
const parseFingerprintPostData = (postData) => {
    if (typeof postData !== 'string') {
        throw new ThreeDsFormattingException(`invalid type for Worldpay fingerprint postMessage data: ${JSON.stringify(postData, null, 2)}`);
    }
    let parsedObj;
    try {
        parsedObj = JSON.parse(postData);
    }
    catch (e) {
        throw new ThreeDsFormattingException(`failed to JSON parse invalid Worldpay fingerprint postData: ${postData}`);
    }
    if (parsedObj.MessageType !== 'profile.completed' ||
        typeof parsedObj.Status !== 'boolean') {
        throw new ThreeDsFormattingException(`invalid format for Worldpay fingerprint postMessage data: ${postData}`);
    }
    return parsedObj;
};
export const performFingerprint = async ({ methodUrl, provider, bin, data: actionData, }) => {
    const browserInfo = collectBrowserInfo();
    const { jwt, correlationId } = actionData;
    function success(sessionId) {
        const dataToServer = {
            sessionId,
            correlationId,
        };
        return {
            fingerprintData: {
                challengeDisplaySize,
                provider,
                received: {},
                data: dataToServer,
                browserInfo,
            },
        };
    }
    function fail(error) {
        const dataToServer = {
            sessionId: '',
            correlationId,
        };
        return {
            fingerprintData: {
                challengeDisplaySize,
                provider,
                notReceived: { error },
                data: dataToServer,
                browserInfo,
            },
        };
    }
    const challengeDisplaySize = getThreeDsChallengeDisplaySize();
    const reqData = {
        Bin: bin,
        JWT: jwt,
    };
    const logData = {
        actionData,
        methodUrl,
        provider,
        reqData,
        correlationId,
    };
    log('3ds: before render 3ds Worldpay fingerprint iframe', logData);
    const fingerprintResultPromise = renderIframeAndWaitForPostback('hidden', methodUrl, 'POST', reqData).then(parseFingerprintPostData);
    try {
        const fingerprintResult = await fingerprintResultPromise;
        const { SessionId: sessionId, Status: status } = fingerprintResult;
        if (status !== true || !sessionId) {
            const err = `bad worldpay fingerprint result: ${stringify(fingerprintResult)}`;
            const ret = fail(err);
            log(`3ds: Worldpay Device Fingerprint failed`, { ...logData, err, ret });
            return ret;
        }
        log('3ds: received Worldpay fingerprint success', {
            ...logData,
            fingerprintResult,
        });
        return success(sessionId);
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'WORLDPAY',
            step: 'fingerprint',
            e,
        }));
        log(`3ds: Worldpay Device Fingerprint failed`, { ...logData, ret, e });
        return ret;
    }
};
//# sourceMappingURL=worldpay-fingerprint.js.map